import React from 'react';
import { t } from 'i18next';
import { PageBar, SlotHost } from '@datanomik/core-ui';

import { ShellPageTitle } from './ShellPageTitle';

export interface ShellPageBarProps {
  title?: React.ReactNode;
  isBeta?: boolean;
  stickyTop?: number;
  hidden?: boolean;
  globalActions?: React.ReactNode;
  leading?: React.ReactNode;
}

export const ShellPageBar: React.FC<ShellPageBarProps> = ({
  title,
  isBeta,
  stickyTop = 0,
  hidden,
  globalActions,
  leading,
}) => (
  <PageBar
    data-modern
    aria-label={t('Page toolbar')}
    stickyTop={stickyTop}
    hidden={hidden}
    leading={leading}
    title={(
      <div className="flex min-w-0 items-center gap-2.5">
        <ShellPageTitle title={title} isBeta={isBeta} />
        <SlotHost name="title-after" className="gap-1.5" />
      </div>
    )}
    tabs={(
      <>
        <SlotHost name="bottom-tabs-desktop" />
        <SlotHost name="bottom-tabs-mobile" />
      </>
    )}
    center={<SlotHost name="page-center" className="justify-center gap-6" />}
    actions={(
      <>
        <SlotHost name="bottom-button-desktop" className="min-w-0 flex-wrap justify-end gap-2" />
        <SlotHost name="top-right" className="min-w-0 flex-wrap justify-end gap-2" />
      </>
    )}
    globalActions={globalActions}
    footer={<SlotHost name="bottom-footer" />}
  />
);

export default ShellPageBar;
